module.exports = __webpack_public_path__ + "media/Educacion.dedb1cb6.mp4";